module.exports = __webpack_public_path__ + "static/img/touxiang.51d13f51.png";